import ProfileConfiguration from "./ProfileConfiguration";
export default ProfileConfiguration;
